import { createGlobalStyle } from 'styled-components';
import 'normalize.css';

export default createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: unset;
  }

  body {
    background: #ebebeb;
    overflow-y: scroll;
    -webkit-font-smoothing: antialiased;
  }

  body, input, button, textarea, select {
    font-size: 16px;
    font-family: Roboto, sans-serif;
  }

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
    outline: 0;
  }

  input[type=button],
  button {
    cursor: pointer;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  p + p {
    margin-top: 16pt;
  }

`;
